
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import Component from "vue-class-component";
import Vue from "vue";
import PracticesTable from "./PracticesTable.vue";

@Component({
    components: {
        HeadingWave,
        PracticesTable
    }
})
export default class Practices extends Vue {
}
